import React, { useEffect } from 'react';
import Link from 'next/link';
import Icon from '@components/common/assets';
import KeywordFilter from '@components/search/KeywordFilter';
import RecommendTagList from '@components/search/searchModal/RecommendTagList';
import RecommendMenuList from '@components/search/searchModal/RecommendMenuList';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './searchModal.module.scss';
const cx = classnames.bind(styles);

interface SearchModalProps {
  onClose: () => void;
}

const SearchModal = ({ onClose }: SearchModalProps) => {
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className={cx('searchModal')}>
      <div className={cx('dimmed')} onClick={onClose} />
      <div className={cx('searchArea')}>
        <Link href={RouteUrl.INDEX} legacyBehavior>
          <a className={cx('logo')} role="button">
            <Icon name="logo" width={80} height={18} />
            <span className={cx('hidden')}>JOBDA</span>
          </a>
        </Link>

        <div className={cx('inputArea')}>
          <div className={cx('inputInner')}>
            <KeywordFilter />

            <div className={cx('keywordArea')}>
              <div className={cx('keywordWrap')}>
                <RecommendTagList />
                <RecommendMenuList />
              </div>
            </div>
          </div>
        </div>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </div>
  );
};

export default SearchModal;
